export default "__VITE_ASSET__ty1j0dxS__"